import Utils from "../../utils/Utils";

export default {

    init() {

        const DATA_TOGGLE = "toggle";
        const DATA_COST_TYPE_ID = "cost-type-id";
        const DATA_COST_ID = "cost-id";
        const DATA_PAYMENT_ID = "payment-id";

        const INPUT_FILTER_COST_TYPE = "#input-filter-cost-type-id";
        const INPUT_FILTER_DATE_FROM = "#input-filter-date-from";
        const INPUT_FILTER_DATE_TO = "#input-filter-date-to";
        const INPUT_FILTER_SITES = ".input-filter-sites"

        const BTN_TOGGLE_TABLE_COST_TYPE_PAYMENTS = ".btn-toggle-table-cost-type-payments";

        const BTN_FILTER_SUBMIT = "#btn-filter-submit";

        const TABLE_COST_TYPES = "#table-cost-types";
        const TABLE_COST_TYPES_BODY = "#table-cost-types tbody";

        const TABLE_COST_TYPES_TAXABLE = "#table-cost-types-taxable";
        const TABLE_COST_TYPES_TAX = "#table-cost-types-tax";
        const TABLE_COST_TYPES_COST_I = "#table-cost-types-cost-i";
        const TABLE_COST_TYPES_TAX_I = "#table-cost-types-tax-i";
        const TABLE_COST_TYPES_TOTAL = "#table-cost-types-total";

        const BTN_MARK_AS_PAID = ".btn-mark-as-paid";

        const BTN_PRINT = "#btn-print";

        const TABLE_COST_TYPES_ITEM_TEMPLATE = ({cost_type}) => `
            <tr class="row-cost-type" data-cost-type-id="${cost_type.id}">
                <td style="width: 50px;min-width: 50px; max-width: 50px">
                    <button class="btn btn-secondary btn-sm btn-toggle-table-cost-type-payments" data-cost-type-id="${cost_type.id}" data-toggle="#table-cost-type-payments-${cost_type.id}">
                        <i class="bx bx-menu"></i>
                    </button>
                </td>
                <td>${Utils.escapeHtml(cost_type.name)}</td>
                <td style="width: 130px; min-width: 130px; max-width: 130px">${numeral(cost_type.accounting.taxable).format('0,0.00')}</td>
                <td style="width: 130px; min-width: 130px; max-width: 130px">${numeral(cost_type.accounting.tax).format('0,0.00')}</td>
                <td style="width: 130px; min-width: 130px; max-width: 130px">${numeral(cost_type.accounting.cost_i).format('0,0.00')}</td>
                <td style="width: 140px; min-width: 140px; max-width: 140px">${numeral(cost_type.accounting.tax_i).format('0,0.00')}</td>
                <td style="width: 140px; min-width: 140px; max-width: 140px">${numeral(cost_type.accounting.total).format('0,0.00')}</td>
            </tr>
            <tr id="table-cost-type-payments-${cost_type.id}" class="row-cost-type-payments" data-cost-type-id="${cost_type.id}" ${!cost_type.expanded ? 'style="display: none;"' : ''}>
                <td colspan="7">
                    <table class="table table-payments">
                        <thead>
                            <tr>
                                <th scope="col"></th>
                                <th scope="col">Pagato</th>
                                <th scope="col">Scadenza</th>
                                <th scope="col">Descrizione</th>
                                <th scope="col" style="width: 130px; min-width: 130px; max-width: 130px">Importo (&euro;)</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${compilePaymentsTable(cost_type)}
                        </tbody>
                    </table>
                </td>
            </tr>
        `;

        const TABLE_COST_TYPE_PAYMENTS_ITEM_TEMPLATE = ({cost_type, payment}) => `
            <tr class="${payment.paid ? 'table-success' : ''}">
                <td>
                    <a href="${BASE_URL}/admin/content/costs/${payment.related_model_id}/edit"
                        class="btn btn-sm btn-primary" target="_blank">
                        <i class="bx bx-folder-open"></i>
                    </a>
                    <button class="btn-mark-as-paid btn btn-success btn-sm ${payment.paid ? 'd-none' : ''}"
                        data-payment-id="${payment.id}"
                        data-cost-type-id="${cost_type.id}">
                        <i class="bx bxl-product-hunt" title="paga"></i>
                    </button>
                </td>
                <td>${payment.paid ? "<i class='font-size-18 bx bx-check'></i>" : ''}</td>
                <td>${moment(payment.expiration).format('DD/MM/YYYY')}</td>
                <td>${Utils.escapeHtml(payment.site_name)} ${!Utils.isEmpty(payment.related_model_date) ? moment(payment.related_model_date).format('DD/MM/YYYY') : ''}<br>${Utils.escapeHtml(payment.description)}</td>
                <td>${numeral(parseFloat(payment.amount)).format('0,0.00')}</td>
            </tr>
        `;

        let _cost_types = [];

        function getFilterSites() {
            const sites = [];

            $(`${INPUT_FILTER_SITES}:checked`).each(function (index, element) {
                sites.push($(element).val());
            });

            return sites;
        }

        function getFilterCostType() {
            return $(INPUT_FILTER_COST_TYPE).val();
        }

        function getFilterDateFrom() {
            return $(INPUT_FILTER_DATE_FROM).val();
        }

        function getFilterDateTo() {
            return $(INPUT_FILTER_DATE_TO).val();
        }

        function getFilterParams() {

            return {
                sites: getFilterSites(),
                date_from: getFilterDateFrom(),
                date_to: getFilterDateTo(),
            }
        }

        function findIndexOfCostType(cost_type_id) {
            return _cost_types.findIndex(cost => parseInt(cost.id) === parseInt(cost_type_id));
        }

        function compilePaymentsTable(cost_type) {

            const data = [];

            if (Array.isArray(cost_type.payments) && cost_type.payments.length > 0) {
                for (const payment of cost_type.payments) {
                    data.push({
                        cost_type: cost_type,
                        payment: payment,
                    });
                }
            }


            return data.map(TABLE_COST_TYPE_PAYMENTS_ITEM_TEMPLATE).join('');
        }

        function paymentsLoaded(cost_type_id, payments, callback) {

            const cost_type_index = findIndexOfCostType(cost_type_id);

            if (cost_type_index > -1) {
                _cost_types[cost_type_index]['payments'] = payments;

                if (callback && "function" === typeof callback) {
                    callback(_cost_types[cost_type_index]);
                }
            }
        }

        function getPaymentsByCostType(cost_type_id, params, callback) {

            httpRequest.get(`admin/content/api/accounting/payments-by-cost-type/${cost_type_id}`, {
                params: params,
            })
                .then(response => paymentsLoaded(cost_type_id, response.data.data, callback))
                .catch(error => {
                });
        }

        function fillCostTypesTable(cost_types) {
            const data = [];

            const accounting = {
                taxable: 0,
                tax: 0,
                cost_i: 0,
                tax_i: 0,
                total: 0,
            }

            for (const cost_type of cost_types) {

                accounting.taxable = accounting.taxable + parseFloat(cost_type.accounting.taxable);
                accounting.tax = accounting.tax + parseFloat(cost_type.accounting.tax);
                accounting.cost_i = accounting.cost_i + parseFloat(cost_type.accounting.cost_i);
                accounting.tax_i = accounting.tax_i + parseFloat(cost_type.accounting.tax_i);
                accounting.total = accounting.total + parseFloat(cost_type.accounting.total);

                data.push({
                    cost_type: cost_type,
                });
            }

            $(TABLE_COST_TYPES_TAXABLE).text(numeral(accounting.taxable).format('0,0.00'));
            $(TABLE_COST_TYPES_TAX).text(numeral(accounting.tax).format('0,0.00'));
            $(TABLE_COST_TYPES_COST_I).text(numeral(accounting.cost_i).format('0,0.00'));
            $(TABLE_COST_TYPES_TAX_I).text(numeral(accounting.tax_i).format('0,0.00'));
            $(TABLE_COST_TYPES_TOTAL).text(numeral(accounting.total).format('0,0.00'));

            const html = data.map(TABLE_COST_TYPES_ITEM_TEMPLATE).join('');

            $(TABLE_COST_TYPES_BODY).html(html);
        }

        function costTypeSelected(cost_type_id) {
            const cost_type_index = findIndexOfCostType(cost_type_id);

            if (cost_type_index > -1) {
                const cost_type = _cost_types[cost_type_index];
                fillCostTypesTable([cost_type]);
            } else {
                fillCostTypesTable(_cost_types);
            }
        }

        function getViewSelectedCostType() {
            return $(INPUT_FILTER_COST_TYPE).val();
        }

        function costTypesLoaded(cost_types) {
            _cost_types = cost_types;
            costTypeSelected(getViewSelectedCostType());
        }

        function getCostTypes() {

            const params = getFilterParams();

            httpRequest.get(`admin/content/api/accounting/cost-types`, {
                params: params,
            })
                .then(response => costTypesLoaded(response.data.data))
                .catch(error => {
                });
        }

        getCostTypes();

        $(BTN_FILTER_SUBMIT).click(function (e) {
            e.preventDefault();
            getCostTypes();

            let print_route = $(BTN_PRINT).data('route');

            const filters = getFilterParams();


            print_route = `${print_route}?date_from=${filters.date_from}&date_to=${filters.date_to}`;

            let sites = [];

            for (let i = 0; i < filters.sites.length; ++i) {
                sites.push(`sites[${i}]=${filters.sites[i]}`);
            }

            if (sites.length > 0) {
                sites = sites.join('&');
                print_route += `&${sites}`;
            }

            $(BTN_PRINT).attr('href', print_route);

        });

        function toggleCostTypeExpanded(cost_type_id) {

            const index = findIndexOfCostType(cost_type_id);

            if (index > -1) {
                _cost_types[index]['expanded'] = !_cost_types[index]['expanded'];
            }
        }

        $(TABLE_COST_TYPES).on('click', BTN_TOGGLE_TABLE_COST_TYPE_PAYMENTS, function (e) {
            e.preventDefault();
            const cost_type_id = $(this).data(DATA_COST_TYPE_ID);
            const target = $(this).data(DATA_TOGGLE);

            const index = findIndexOfCostType(cost_type_id);

            if (index > -1) {

                if (!_cost_types[index]['expanded']) {

                    const cost_type = _cost_types[index];

                    const params = getFilterParams();

                    if (!cost_type.payments || cost_type.payments.length === 0) {
                        getPaymentsByCostType(cost_type_id, params, function (cost_type) {
                            $(target).find(`tbody`).html(compilePaymentsTable(cost_type));
                            toggleCostTypeExpanded(cost_type_id);
                            $(target).show();
                        });
                    } else {
                        toggleCostTypeExpanded(cost_type_id);
                        $(target).show();
                    }
                } else {
                    toggleCostTypeExpanded(cost_type_id);
                    $(target).hide();
                }
            }
        });

        function paymentMarkedAsPaid(payment, callback) {

            if (callback && typeof callback === "function") {
                callback(payment);
            }
        }

        function markPaymentAsPaid(payment_id, callback) {

            httpRequest.put(`admin/content/api/payments/${payment_id}/mark-as-paid`)
                .then(response => paymentMarkedAsPaid(response.data.data, callback))
                .catch(error => {

                });
        }

        $(TABLE_COST_TYPES).on('click', BTN_MARK_AS_PAID, function (e) {
            e.preventDefault();

            const payment_id = $(this).data(DATA_PAYMENT_ID);
            const cost_type_id = $(this).data(DATA_COST_TYPE_ID);

            markPaymentAsPaid(payment_id, function (payment) {

                const cost_type_index = findIndexOfCostType(cost_type_id);

                if (cost_type_index > -1) {
                    const payment_index = _cost_types[cost_type_index].payments.findIndex(payment => parseInt(payment.id) === parseInt(payment_id));

                    if (payment_index > -1) {
                        _cost_types[cost_type_index].payments[payment_index] = payment;
                        const html = compilePaymentsTable(_cost_types[cost_type_index]);
                        $(TABLE_COST_TYPES).find(`#table-cost-type-payments-${cost_type_id} tbody`).html(html)
                    }
                }
            });
        });

        $(INPUT_FILTER_COST_TYPE).change(function (e) {
            const cost_type_id = $(this).val();
            costTypeSelected(cost_type_id);
        });
    },

    finalize() {

    },
}
